module.exports = __webpack_public_path__ + "img/tabbed-search-filter-chevy.6500a8af.png";